var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-content",attrs:{"id":"app"}},[_c('router-view'),_c('Tabbar',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowBar),expression:"isShowBar"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }